import React from "react";

function AptisCard(props) {
  return (
    <div
      className={`flex flex-col p-4 justify-center items-center rounded-30 gap-2 ${props.class} transform transition-transform duration-300 hover:-translate-y-2 bg-cyan-50 shadow-[0px_3px_3px_0px_rgba(0,_0,_0,_0.3)]`}
    >
      <i class={props.icon}></i>
      <p className="font-bold text-xl text-center ">{props.title}</p>
      <p className="text-sm text-center">{props.description}</p>
    </div>
  );
}

export default AptisCard;
